import { Box, Typography } from "@mui/material"
import { ReactNode } from "react"

export type MetadataFormSectionCardProps = {
  id: string
  title: string
  children: ReactNode
}

export const MetadataFormSectionCard = ({ id, title, children }: MetadataFormSectionCardProps) => {
  return (
    <Box
      id={id}
      sx={{
        scrollMarginTop: "50px",
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        p: 2,
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
        {title}
      </Typography>
      {children}
    </Box>
  )
}

export default MetadataFormSectionCard
